/**
 * usePageTitle Hook
 *
 * Sets the browser tab title dynamically.
 * Format: "XLR8 | Page Name" or just "XLR8" for landing.
 */
import { useEffect } from "react";

export function usePageTitle(pageTitle?: string) {
  useEffect(() => {
    // If no page title provided, just show "XLR8"
    // Otherwise show "XLR8 | Page Name"
    document.title = pageTitle ? `XLR8 | ${pageTitle}` : "XLR8";

    // Cleanup: reset to default when component unmounts
    return () => {
      document.title = "XLR8";
    };
  }, [pageTitle]);
}

export default usePageTitle;
